import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const removeProductFromCartApi = (data) =>
    Promise.resolve(axios.post(endpoints.removeProductFromCart, data));
